<template>
  <div class="container">
    <div class="container__body">
      <div class="container__body__top"></div>
      <div class="container__body__center">
        <span v-if="IsIos"
              class="container__body__center__ios">上海律师iOS客户端</span>
        <span v-else-if="IsAndroid"
              class="container__body__center__ios">上海律师Android客户端</span>
        <span class="container__body__center__text">为律师提供方便快捷的协作平台</span>
      </div>
      <div class="container__body__bottom">
        <van-button v-if="IsIos"
                    class="button"
                    @click="openPopup()"
                    round
                    type="info"
                    size="large">下载iOS客户端</van-button>
        <van-button v-else-if="IsAndroid"
                    class="button"
                    @click="openAndroid()"
                    round
                    type="info"
                    size="large">下载Android客户端</van-button>
      </div>
      <van-dialog class="dialog"
                  v-model="Show"
                  title="登录"
                  show-cancel-button>
        <div class="container__dialog">
          <!-- <span class="container__dialog__text">
            下载之前，需要进行一个资格验证,
            请输入您的上海市律师协会OA系统登录账号和密码
          </span> -->
          <div class="vip__username">
            <span class="vip__username__span">会员号/手机号/执业证号/实习证号</span>
            <input type="text"
                   placeholder="请输入"
                   v-model="Username"
                   class="vip__username__input" />
          </div>
          <div class="vip__username">
            <span class="vip__username__span">密码<span style="margin-left: 0.1rem;color: gray;font-weight: 400;">请使用您登录东方律师网使用的密码</span></span>
            <input type="password"
                   placeholder="请输入"
                   v-model="Password"
                   class="vip__username__input" />
            <a href="http://passport3.lawyers.org.cn/findpwd.jsp"
               class="forget">忘记密码</a>
          </div>
          <van-checkbox class="check-box"
                        :class="{'isSelect': !(hasSelect || checked)}"
                        icon-size=".3rem"
                        v-model="checked"
                        shape="square">勾选此项，表示您同意<span class="check-info"
                  @click="goPrivacy()">隐私条款及用户协议</span> </van-checkbox>
          <div class="container__dialog__button container__dialog__button-a">
            <van-button round
                        block
                        style="height: 1rem;"
                        type="info"
                        :loading="isLoading"
                        class="container__dialog__button__confirm"
                        @click="Confirm()">登录</van-button>
            <!-- <van-button color="#eeeeee"
                        round
                        style="height: 1rem;"
                        block
                        class="container__dialog__button__signout"
                        @click="signOut()">退出</van-button> -->
          </div>
        </div>
      </van-dialog>
      <van-dialog class="dialog-active"
                  v-model="tipShow"
                  title="提示"
                  show-cancel-button>
        <div class="container__dialog"
             style="padding-top:0.8rem;font-size: 0.45rem;">
          {{tips}}
        </div>
      </van-dialog>
      <van-dialog class="dialog-active"
                  v-model="active"
                  title="激活"
                  show-cancel-button>
        <div class="container__dialog">

          <div class="active-box">点击“激活”，表示您同意将您的姓名，手机号，执业机构等信息授权给运营方/技术服务提供方。</div>
          <!-- <div class="active-box">请注意，后续登录时您将收到技术支持服务提供商飞书发送的手机验证码。</div> -->
          <div class="container__dialog__button container__dialog__button-a">
            <van-button round
                        block
                        style="height: 1rem;"
                        type="info"
                        class="container__dialog__button__confirm"
                        @click="activeInfo()">激活</van-button>
            <van-button color="#eeeeee"
                        round
                        style="height: 1rem;"
                        block
                        class="container__dialog__button__signout"
                        @click="signOut()">取消</van-button>
          </div>
        </div>
      </van-dialog>
      <van-dialog class="dialogsecond"
                  v-model="Showsecond"
                  title="安装说明"
                  show-cancel-button>
        <div class="container__dialog">
          <p class="container__dialog__p">1. 如何快速安装ios客户端?</p>
          <span class="container__dialog_span">
            点击【立即下载】将会跳转【itunes store】 自动下载APP。
          </span>
          <p class="container__dialog__p">
            2. 跳转【itunes store】需要输入密码的情况
          </p>
          <span class="container__dialog_span">
            输入AppleID对应的密码，即可完成下载。
          </span>
          <p class="container__dialog__p">
            3. 没有安装【itunes store】怎么办？
          </p>
          <span class="container__dialog_span">
            打开手机本地的【App Store】, 下载安装【itunes store】,
            安装完成后回到本页面,点击【立即下载】, 将跳转【itunes
            store】自动下载APP。
          </span>
          <div class="container__dialog__button">
            <van-button round
                        block
                        type="info"
                        style="height: 1rem;"
                        class="container__dialog__button__confirm"
                        @click="Downloadnow()">立即下载</van-button>
            <van-button color="#eeeeee"
                        round
                        block
                        style="height: 1rem;"
                        class="container__dialog__button__signout"
                        @click="donotdownload()">暂不下载</van-button>
          </div>
        </div>
      </van-dialog>
    </div>
    <div class="container__footer"></div>
    <div class="isWeiChart"
         v-if="isShow"
         @click="touch()">
      <div class="inner-box"></div>
    </div>
  </div>
</template>
<script>
import api from "@/api/index.js";
import KeyEncrypt from '../../plugin/key-encrypt-utils'
export default {
  name: "IOSclient",
  data () {
    return {
      IsIos: true,
      IsAndroid: true,
      Show: true,
      tipShow: false,
      Showsecond: false,
      Username: "",
      Password: "",
      isShow: false,
      isLoading: false,
      mobileModel: '',
      checked: false,
      hasSelect: true,
      active: false,
      secureKey: ''
    };
  },
  created () {
    this.getKey();
    // this.getVerify();
    this.goMobile();
    this.isWeiChart();
  },
  methods: {
    goPrivacy () {
      this.$router.push("/app-privacy");
    },
    // 点击下载苹果客户端打开验证弹框
    openPopup () {
      this.Show = true;
    },
    // 苹果页面验证点击退出
    signOut () {
      this.Show = true;
      this.active = false;
      this.Username = "";
      this.Password = "";
    },
    // 苹果点击确认
    Confirm () {
      if (this.Username === "") {
        this.$toast.fail("请输入账号");
      } else if (this.Password === "") {
        this.$toast.fail("请输入密码");
      } else if (!this.checked) {
        this.hasSelect = false;
      } else {
        var ke = new KeyEncrypt();
        const encryptedPassword = ke.encrypt(
          this.Password,
          this.secureKey
        );
        const data = {
          j_username: this.Username,
          j_password: encryptedPassword,
          responseType: 'json'
        };
        this.isLoading = true;
        api.login(data).then((res) => {
          this.isLoading = false;
          if (res.data.code === 200) {
            this.$toast.setDefaultOptions({ duration: 200 });
            this.$toast.success("验证通过");
            this.Show = false;
            this.active = true;
            this.getVerify();
          } else {
            this.$toast.setDefaultOptions({ duration: 2000 });
            return this.$toast.fail("账号或密码错误，如果您是使用手机号码不能登录，也有可能是与留存在上海律协的手机号信息不一致，建议您使用其它方式进行登录");
          }
        });
      }
    },
    getKey () {
      api.getKey().then(res => {
        const result = res.data;
        if (result.code === 1) {
          this.secureKey = result.result;
        }
      })
    },
    getVerify () {
      // debugger
      api.getVerify().then(res => {
        console.log(res);
        if (res.data.code !== 1) {
          this.tipShow = true
          this.active = false;
          this.tips = res.data.description
        }
      })
    },
    // 安卓点击下载
    openAndroid () {
      const params = {
        device: "android",
      };
      api.getModelVerification(params).then((res) => {
        window.location.href = res.data.result;
      });
    },
    donotdownload () {
      this.Showsecond = false;
    },
    // 苹果点击下载
    Downloadnow () {
      const params = {
        device: "ios",
      };
      api.getModelVerification(params).then((res) => {
        window.location.href = res.data.result;
      });
    },
    // 判断手机机型
    goMobile () {
      // var sUserAgent = navigator.userAgent.toLowerCase();
      // var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
      // var bIsIphoneOs = sUserAgent.match(/iphone/i) == "iphone";
      // if (!bIsIpad && !bIsIphoneOs) {
      //   this.IsIos = false;
      // }
      this.IsIos = this.isIOS();
      this.mobileModel = this.IsIos ? 'ios' : 'android';
    },
    isIOS () {
      return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    },
    activeInfo () {
      api.getUserinformation().then(res => {
        if (res.data.code === 1) {
          this.active = false
          this.mobileModel === 'ios' ? this.Showsecond = true : '';
        } else {
          this.$toast.fail(res.data.description);
        }
      })
    },
    // 判断浏览器是否是微信浏览器
    isWeiChart () {
      var ua = navigator.userAgent.toLowerCase();
      this.isShow = ua.match(/MicroMessenger/i) == "micromessenger";
    },
    // 蒙版点击
    touch () {
      this.isShow = false;
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
  .container__body {
    width: 100%;
    height: 100%;
    background: url("~@src/assets/img/background2.png") no-repeat;
    background-size: cover;
    .container__body__top {
      width: 2.18rem;
      height: 2.18rem;
      margin: 0 auto;
      margin-top: 2.7rem;
      background: url("~@src/assets/img/lawyer.png") no-repeat;
      background-size: 100% 100%;
    }
    .container__body__center {
      margin-top: 0.9rem;
      text-align: center;
      .container__body__center__ios {
        display: block;
        font-weight: bold;
        font-family: PingFang SC;
        font-size: 0.6rem;
        color: rgba(0, 0, 0, 0.8);
      }
      .container__body__center__text {
        line-height: 1rem;
        font-size: 0.3rem;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        opacity: 1;
      }
    }
    .container__body__bottom {
      padding-top: 0.5rem;
      text-align: center;
      .button {
        width: 4rem;
        height: 1rem;
        font-family: PingFang SC;
        font-size: 0.3rem;
      }
    }
  }
  .dialog {
    width: 70%;
    box-sizing: border-box;
    .container__dialog {
      width: 100%;
      // height: 9rem;
      padding: 0.2rem 0 1rem;
      .container__dialog__text {
        width: 6rem;
        display: inline-block;
        padding: 0 2em;
        text-align: left;
        font-family: PingFang SC;
        font-size: 0.28rem;
        color: #007aff;
      }
      .vip__username {
        padding-top: 0.7rem;
        padding-left: 0.5rem;
        text-align: left;
        .vip__username__span {
          display: block;
          margin-bottom: 0.2rem;
          font-size: 0.26rem;
          font-family: PingFang SC;
          font-weight: bold;
        }
        .vip__username__input {
          height: 0.8rem;
          width: 5.7rem;
          padding-left: 0.2rem;
          background: rgba(0, 0, 0, 0.03);
          border: 1px solid rgba(0, 0, 0, 0.2);
          outline: none;
          font-size: 0.3rem;
          opacity: 1;
          border-radius: 8px;
        }
      }
      .container__dialog__button-a {
        padding: 0 0.5rem;
        .container__dialog__button__confirm {
          margin-top: 0.5rem;
        }
        .container__dialog__button__signout {
          margin-top: 0.5rem;
          .van-button__text {
            font-family: PingFang SC;
            color: #000;
          }
        }
      }
    }
  }
  .dialog-active {
    // height: 10.5rem;
    width: 75%;
    box-sizing: border-box;
    .container__dialog {
      width: 100%;
      // height: 9rem;
      padding: 0.2rem 0 1rem;
      .container__dialog__text {
        width: 6rem;
        display: inline-block;
        padding: 0 2em;
        text-align: left;
        font-family: PingFang SC;
        font-size: 0.28rem;
        color: #007aff;
      }
      .vip__username {
        padding-top: 0.7rem;
        padding-left: 0.5rem;
        text-align: left;
        .vip__username__span {
          display: block;
          margin-bottom: 0.2rem;
          font-size: 0.26rem;
          font-family: PingFang SC;
          font-weight: bold;
        }
        .vip__username__input {
          height: 0.8rem;
          width: 5.7rem;
          padding-left: 0.2rem;
          background: rgba(0, 0, 0, 0.03);
          border: 1px solid rgba(0, 0, 0, 0.2);
          outline: none;
          font-size: 0.3rem;
          opacity: 1;
          border-radius: 8px;
        }
      }
      .container__dialog__button-a {
        padding: 0 0.5rem;
        .container__dialog__button__confirm {
          margin-top: 0.5rem;
        }
        .container__dialog__button__signout {
          margin-top: 0.5rem;
          .van-button__text {
            font-family: PingFang SC;
            color: #000;
          }
        }
      }
    }
  }
  .dialogsecond {
    width: 75%;
    box-sizing: border-box;
    .container__dialog {
      width: 100%;
      padding: 0.2rem 0 1rem;
      text-align: left;
      .container__dialog__p {
        padding: 0 3em;
        text-align: center;
        line-height: 0.5rem;
        text-align: left;
        font-size: 0.25rem;
        color: #007aff;
      }
      .container__dialog_span {
        text-align: center;
        display: inline-block;
        padding-left: 4em;
        padding-right: 3em;
        line-height: 0.5rem;
        text-align: left;
        font-size: 0.25rem;
        color: rgba(0, 0, 0, 0.45);
      }
      .container__dialog__button {
        padding: 0 0.5rem;
        .container__dialog__button__confirm {
          margin-top: 0.5rem;
        }
        .container__dialog__button__signout {
          margin-top: 0.5rem;
          .van-button__text {
            font-family: PingFang SC;
            color: #000;
          }
        }
      }
    }
  }
  .button {
    width: 4rem;
    height: 0.8rem;
    margin-top: 4rem;
    line-height: 0.8rem;
    font-family: PingFang SC;
    font-size: 0.27rem;
  }
  /deep/ .van-dialog__confirm,
  .van-dialog__confirm:active {
    display: none;
  }
  /deep/ .van-dialog__footer--buttons .van-button {
    display: none;
  }
  /deep/ .van-dialog__header {
    padding: 0.25rem;
    padding-left: 2em;
    text-align: left;
    font-size: 0.32rem;
    font-weight: bold;
    border-bottom: 1px solid rgba(0, 0, 0, 0.14901960784313725);
  }
  .container__footer {
    height: 2rem;
    width: 100%;
    background: url("~@src/assets/img/wave2.png");
  }
}
.check-box {
  padding: 0.3rem 0.3rem 0 0.5rem;
  vertical-align: top;
  line-height: 0.3rem;
  text-align: left;
  font-size: 0.24rem;
}
.check-info {
  color: #007aff;
}
.isSelect {
  /deep/ .van-checkbox__label {
    color: red;
  }
}
/deep/ .van-checkbox__label {
  line-height: 0.3rem;
}
.forget {
  display: block;
  padding: 0.3rem 0.5rem 0 0;
  font-size: 0.24rem;
  text-align: right;
}
.active-box {
  padding: 0.1rem 0.65rem;
  text-align: left;
  font-size: 0.55rem;
}
.isWeiChart {
  display: flex;
  justify-content: center;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 2rem 0 0 0.5rem;
  font-size: 0.5rem;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2100;
}
.inner-box {
  width: 5.68rem;
  height: 4.75rem;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-image: url("~@src/assets/img/isWeiChart.png");
}
</style>
